import { Spin } from 'antd';
import React from 'react';

import { WarningOutlined } from '@ant-design/icons';
import PreparingIcon from '@icons/preparing.svg';

import { CardWrapper, Layer, Loader, StyledButton } from './styled';

const RETRY_TXT = {
  msg: 'Please try again',
  btn: 'Retry',
  err: 'Error loading data',
};

const DONE_TXT = {
  msg: 'An error was encountered while processing your request. Please try again later or reach out to Conviva Support.',
  btn: 'Contact',
  err: 'Something went wrong',
};

function WarningIcon() {
  return <WarningOutlined style={{ color: '#ff6347' }} className="mr-2" />;
}

export function DefaultLayer() {
  return (
    <>
      <Layer data-testid="layer" key="layer" />
      <Loader data-testid="loader" key="loader">
        <Spin />
      </Loader>
    </>
  );
}

export function RetryCard({ onClick, theme = 'light', horizontal = false }) {
  return (
    <CardWrapper horizontal={horizontal}>
      <span>
        <WarningIcon />
        {RETRY_TXT.err}
      </span>
      <div className="message">{RETRY_TXT.msg}</div>
      <StyledButton id="retry-button" type="primary" ghost primary onClick={onClick} theme={theme}>
        {RETRY_TXT.btn}
      </StyledButton>
    </CardWrapper>
  );
}

export function ContactCard({ onClick, theme = 'light', horizontal = false }) {
  return (
    <CardWrapper horizontal={horizontal}>
      <span>
        <WarningIcon />
        {DONE_TXT.err}
      </span>
      <div className="message">{DONE_TXT.msg}</div>
      <StyledButton
        id="contact-button"
        type="primary"
        ghost
        primary={false}
        onClick={onClick}
        theme={theme}
      >
        <a href="/app/pulse/support" target="_BLANK">
          {DONE_TXT.btn}
        </a>
      </StyledButton>
    </CardWrapper>
  );
}

export function PreparingData({ horizontal = false }) {
  return (
    <>
      <Layer key="layer" />
      <Loader style={{ width: 'auto', maxWidth: 'none' }} key="loader">
        <CardWrapper horizontal={horizontal}>
          <div style={{ fontSize: '3em' }}>
            <PreparingIcon />
          </div>
          <div style={{ fontWeight: 400 }}>Preparing Data</div>
          <div style={{ fontSize: '0.9em', fontWeight: 300 }}>
            We are aggregating this data from millions of events, should not take more than 20
            seconds.
          </div>
        </CardWrapper>
      </Loader>
    </>
  );
}
